<template>
  <BreadCrumb ImageUrl="" PageName="マージン率等の情報公開" />
  <!-- End reinfo_breadcrumb section -->
  <section class="blog-grid">
    <div class="container">
      <div class="block-title text-center" data-aos="fade-right" :data-aos-duration="500">
        <p style="width:100%" class="color-1"><span>マージン率等の情報公開</span></p>
      </div>

      <div class="row post_content margin-info">
        <p class="margin-info__title" data-aos="fade-right" :data-aos-duration="500">
          マージン率等の情報公開
        </p>

        <p class="margin-info__company" data-aos="fade-right" :data-aos-duration="500">
          AUM 株式会社
        </p>

        <p class="margin-info__text" data-aos="fade-right" :data-aos-duration="500">
          労働者派遣法第23条第5項に基づき、下記の情報を公開いたします。
        </p>
        <p class="margin-info__text" data-aos="fade-right" :data-aos-duration="500">
          対象期間：2025年3月1日～2026年2月28日
        </p>

        <div class="margin-info__item" data-aos="fade-right" :data-aos-duration="500">
          <p class="margin-info__label">1．派遣労働者の数</p>
          <p class="margin-info__value">3名</p>
        </div>

        <div class="margin-info__item" data-aos="fade-right" :data-aos-duration="500">
          <p class="margin-info__label">2．派遣先事業所数</p>
          <p class="margin-info__value">1事業所</p>
        </div>

        <div class="margin-info__item" data-aos="fade-right" :data-aos-duration="500">
          <p class="margin-info__label">3．労働者派遣に関する料金の平均額</p>
          <p class="margin-info__value">39,000円（1日8時間当たり）</p>
        </div>

        <div class="margin-info__item" data-aos="fade-right" :data-aos-duration="500">
          <p class="margin-info__label">4．派遣労働者の賃金の平均額</p>
          <p class="margin-info__value">30,000円（1日8時間当たり）</p>
        </div>

        <div class="margin-info__item" data-aos="fade-right" :data-aos-duration="500">
          <p class="margin-info__label">5．マージン率</p>
          <p class="margin-info__value">21.9％</p>
        </div>

        <p class="margin-info__note" data-aos="fade-right" :data-aos-duration="500">
          ※マージンには、社会保険料（健康保険・厚生年金保険・雇用保険等）、教育訓練費、福利厚生費、有給休暇費用、会社運営費等が含まれています。
        </p>

        <div class="margin-info__item" data-aos="fade-right" :data-aos-duration="500">
          <p class="margin-info__label">6．教育訓練に関する事項</p>
          <p class="margin-info__value">・情報セキュリティ研修</p>
          <p class="margin-info__value">・コンプライアンス・ハラスメント防止研修</p>
        </div>

        <div class="margin-info__item" data-aos="fade-right" :data-aos-duration="500">
          <p class="margin-info__label">7．キャリアコンサルティング相談窓口</p>
          <p class="margin-info__value">相談窓口：管理部</p>
          <p class="margin-info__value">連絡先：03-6874-5334</p>
        </div>

        <div class="margin-info__item" data-aos="fade-right" :data-aos-duration="500">
          <p class="margin-info__label">8．労使協定締結の有無</p>
          <p class="margin-info__value">有（労働者派遣法第30条の4第1項の労使協定を締結）</p>
        </div>

        <div class="margin-info__item" data-aos="fade-right" :data-aos-duration="500">
          <p class="margin-info__label">9．労使協定の対象となる派遣労働者の範囲</p>
          <p class="margin-info__value">全ての派遣労働者</p>
        </div>

        <div class="margin-info__item" data-aos="fade-right" :data-aos-duration="500">
          <p class="margin-info__label">10．労使協定の有効期間</p>
          <p class="margin-info__value">2026年4月1日～2027年3月31日</p>
        </div>
      </div>
    </div>
    <!-- /.container -->
  </section>
</template>

<script>
import BreadCrumb from "../components/BreadCrumb";

export default {
  name: "News",
  components: { BreadCrumb }
}
</script>

<style scoped>
@media (max-width: 790px) {
  .sm_no_show {
    display: none !important;
  }
  .pb10 {
    padding-bottom: 15px !important;
  }
  .page-header {
    padding-top: 119px !important;
  }
  .banner-background-02 {
    top: 282px !important;
  }
  .banner-background-01 {
    top: 271px !important;
  }
  .service-one {
    padding-top: 30px !important;
  }
}

.margin-info {
  max-width: 760px;
  margin: 0 auto;
  color: #222;
  font-size: 16px;
  line-height: 1.9;
}

.margin-info p {
  width: 100%;
  margin-bottom: 0;
}

.margin-info__title {
  margin-bottom: 28px !important;
  font-size: 18px;
  font-weight: 500;
}

.margin-info__company {
  margin-bottom: 28px !important;
  font-size: 18px;
}

.margin-info__text {
  margin-bottom: 4px !important;
}

.margin-info__item {
  width: 100%;
  margin-top: 16px;
}

.margin-info__label {
  font-weight: 400;
}

.margin-info__value {
  padding-left: 36px;
}

.margin-info__note {
  margin-top: 8px;
}

.contact-two__info-content p a{
      color: #007bff!important;
}

@media (max-width: 790px) {
  .margin-info {
    max-width: 100%;
    font-size: 15px;
    line-height: 1.8;
    padding: 0 5px;
  }

  .margin-info__value {
    padding-left: 24px;
  }
}
</style>